import { createPortal } from 'react-dom'

import { Drawer, Layout, Text } from '@loadsmart/miranda-react'

import { DrawerBody, DrawerHeader, DrawerWrapper, LoadingIcon } from './Chat.styles'
import { Chatbox } from './ChatBox'
import { useChatContext } from './ChatContext'

export type ChatWindowProps = {
  isOpen: boolean
  onClose: () => void
  onClosed: () => void
}

export function ChatWindow({ isOpen, onClose, onClosed }: ChatWindowProps) {
  const { conversation, subject, subtitle } = useChatContext()

  return createPortal(
    <Drawer open={isOpen} onClose={onClose} onClosed={onClosed} size="medium">
      <DrawerHeader>
        <Text variant="heading-md-bold" color="color-text-primary">
          {subject}
        </Text>
        <Drawer.Close data-testid="chatWindowCloseButton" onClick={onClose} />
      </DrawerHeader>
      <DrawerBody>
        <DrawerWrapper>
          <Layout.Sidebar reversed gap="none" paddingX="spacing-2" paddingY="none">
            <Layout.Sidebar.Content>
              <Text variant="body-sm" color="color-text-tertiary">
                {subtitle}
              </Text>
            </Layout.Sidebar.Content>
          </Layout.Sidebar>
          {conversation ? (
            <Chatbox conversationId={conversation.uuid} />
          ) : (
            <LoadingIcon aria-label="loading..." />
          )}
        </DrawerWrapper>
      </DrawerBody>
    </Drawer>,
    document.body
  )
}
